exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-message[data-v-240c7fdc]{padding:16px 20px;border-radius:8px;display:flex;align-items:center;gap:12px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,sans-serif;font-size:15px;line-height:1.5}.status-message.error[data-v-240c7fdc]{background-color:#fef2f2;border:1px solid #fee2e2;color:#991b1b}.status-message.error .icon[data-v-240c7fdc]{color:#dc2626}.status-message .icon[data-v-240c7fdc]{flex-shrink:0;width:20px;height:20px}.status-message.error a[data-v-240c7fdc]{color:inherit;text-decoration:underline}.status-message.error a[data-v-240c7fdc]:hover{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-240c7fdc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Stripe/ErrorResponse.vue
// module id = KTgz
// module chunks = 0